import initMK from '../_core/init.js';
import defineProp from '../_core/defineprop.js';
import set from '../set.js';
var fieldKeys = ['Model', 'itemRenderer'];
// a native class field (`Model = X`) replaces the accessor installed in the constructor
// so put the accessor back and assign the field value through it; returns the object definition
export default function syncFields(self) {
  var def = initMK(self);
  for (var i = 0; i < fieldKeys.length; i++) {
    var key = fieldKeys[i];
    var descriptor = Object.getOwnPropertyDescriptor(self, key);
    if (descriptor && 'value' in descriptor && def.props[key]) {
      var value = descriptor.value;
      delete self[key];
      delete def.props[key];
      defineProp(self, key);
      set(self, key, value);
    }
  }
  return def;
}